function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#157BFA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.807 15.62L12 13.04l-1.877-2.2a1.263 1.263 0 010-1.66L12 6.98l-2.173-2.6L9.511 4H5.66C4.751 4 4 4.76 4 5.68v8.64c0 .92.75 1.68 1.66 1.68H9.51l.296-.38z",
  fill: "#62DA97"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.558 4h-2.49l1.563 2.12c.36.48.36 1.18 0 1.66L12 9.98l1.63 2.2c.361.48.361 1.18 0 1.66L12.07 16h2.489c.79 0 1.442-.76 1.442-1.68V5.68C16 4.76 15.348 4 14.558 4z",
  fill: "#fff"
});

var SvgBoo = function SvgBoo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boo.35b1a1b9.svg";
export { ForwardRef as ReactComponent };